import React from "react"
import PropTypes from "prop-types"
import { GatsbyImage } from "gatsby-plugin-image"

const DynamicImageViewer = ({ image, alt, className, style }) => {
  return image.gatsbyImageData ? (
    <GatsbyImage
      alt={alt}
      image={image.gatsbyImageData}
      className={className}
      imgStyle={style}
    />
  ) : (
    <img
      src={image.file.url}
      alt={alt}
      loading="lazy"
      className={className}
      style={style}
    />
  )
}

DynamicImageViewer.propTypes = {
  image: PropTypes.object,
  alt: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.string,
}

export default DynamicImageViewer
